<template>
    <div>
        <div class="praise-box">
            <div class="praise-content dis-flex">
                <div class="top-box block-box dis-flex align-items" @click="handleShowTip">
                    <img src="@/assets/images/help.png" alt="">
                </div>
                <div class="text-box">Help</div>

                <div class="bottom-box block-box dis-flex" @click="handleLike">
                    <img class="thumbs-up" src="@/assets/images/hand-active.png" v-if="isLike" :class="{'active': highLike}">
                    <img class="thumbs-up" src="@/assets/images/hand.png" v-else>
                    <div class="num-box" :class="{'active': isLike}">{{ count | countFilter }}</div>
                    <!-- 爱心动画 -->
                    <div class="heart-one" :class="{'active': highLike}"></div>
                    <div class="heart-two" :class="{'active': highLike}"></div>
                    <div class="heart-three" :class="{'active': highLike}"></div>
                </div>
                <div class="text-box">Like</div>
            </div>
        </div>
        <!-- 登录弹窗 -->
        <Modal 
            v-model="showLogin"
            :footer-hide="true"
            :closable="false"
            :mask-closable="false"
            width="40"
            class-name="vertical-center-modal"
            >
            <div>
                <login-modal @handleClose="showLogin = false;" @loginSuccess="listenLogin"/>
            </div>
        </Modal>
        <!-- 帮助提示 -->
        <Modal 
            v-model="showTips"
            :footer-hide="true"
            :closable="false"
            width="700"
            class-name="vertical-center-modal"
            >
            <div class="tipsModal-box">
                <div class="tipsModal-title font-bolder">Hints</div>
                <template v-if="headType == 1">
                    <div style="margin-bottom: 15px;">On the left side, find out or customize the appliances that you will use when off-grid, and add them to the RV by clicking.</div>
                    <div style="margin-bottom: 15px;">The selected appliances will be displayed in the middle, and their key parameters are shown on the right side.</div>
                    <div style="margin-bottom: 15px;">Pay attention to the parameters of the chosen appliances. <b>You can adjust them</b> according to the actual situation.</div>
                    <div style="margin-bottom: 15px;">For those appliances that will be powered simultaneously, please tick the box of <b>"Working in peak hours"</b>.</div>
                    <div>Any questions or suggestions, please turn to <a href="https://renogy.com/contact-us/" target="blank" style="font-weight: bold;" class="font-bolder">renogy.com/contact-us/</a>. Remember to enter <b>"#Calculator"</b> in the Subject field when submitting a case.</div>
                </template>
                <template v-if="headType == 2">
                    <div style="margin-bottom: 15px;">Follow the steps to determine your suitable products, mainly including the inverter, batteries, solar panels, and the solar charge controller.</div>
                    <div style="margin-bottom: 15px;">According to your selected appliances and choices, the system will automatically filter out the unsuitable options. </div>
                    <div style="margin-bottom: 15px;">There are some tips or product information in the bottom right corner to help you with decision-making.</div>
                    <div style="margin-bottom: 15px;">Key Metrics are shown in the top right corner for you to know the system's configuration.</div>
                    <div>Any questions or suggestions, please turn to <a href="https://renogy.com/contact-us/" target="blank" style="font-weight: bold;" class="font-bolder">renogy.com/contact-us/</a>. Remember to enter <b>"#Calculator"</b> in the Subject field when submitting a case.</div>
                </template>
                <template v-if="headType == 3">
                    <div>Any questions or suggestions, please turn to <a href="https://renogy.com/contact-us/" target="blank" style="font-weight: bold;" class="font-bolder">renogy.com/contact-us/</a>. Remember to enter <b>"#Calculator"</b> in the Subject field when submitting a case.</div>
                </template>
                <template v-if="headType == 4">
                    <div>Any questions or suggestions, please turn to <a href="https://renogy.com/contact-us/" target="blank" style="font-weight: bold;" class="font-bolder">renogy.com/contact-us/</a>. Remember to enter <b>"#Calculator"</b> in the Subject field when submitting a case.</div>
                </template>
                <div class="tipsModal-button">
                    <div style="margin: 20px auto 0;cursor: pointer;" @click="showTips = false">OK</div>
                </div>
            </div>
        </Modal>
    </div>
</template>
<script>

    import LoginModal from '@/components/loginModal/LoginModal.vue';
    import { dealCode } from '@/js/lib/dealCode';

    export default {
        components: {
            LoginModal
        },
        props: {
            headType: {
                type: Number,
                default: 1
            },
            step: null,
        },
        data() {
            return {
                count: '2',
                isLike: 0,
                userToken: '',
                showLogin: false,
                highLike: false,
                showTips: false
            }
        },
        mounted() {
            this.userToken = localStorage.getItem('userToken');
            this.getLike();
        },
        methods: {
            handleShowTip() {
                this.showTips = true;
                if(this.headType == 1) {
                    gtag('event', 'page_ask_for_help_rv', {
                        'send_to': 'G-VVXR7PJV6C',
                        'page_ask_for_help_rv': "Electrical Appliances"
                    });
                }else if(this.headType == 2) {
                    let state = 'Solar System Setup';
                    switch(this.step) {
                        case 1:
                            state = 'Select DC Platform Voltage';
                            break;
                        case 2:
                            state = 'Select Inverter Type';
                            break;
                        case 3:
                            state = 'Select Inverter Model';
                            break;
                        case 4:
                            state = 'Select Battery Type';
                            break;
                        case 5:
                            state = 'Select Rated Voltage';
                            break;
                        case 6:
                            state = 'Select Battery Model';
                            break;
                        case 7:
                            state = 'PSH';
                            break;
                        case 8:
                            state = 'Select the roof area(s) that you want to install solar panels';
                            break;
                        case 9:
                            state = 'Select flexible solar panel(s) for curved area';
                            break;
                        case 10:
                            state = 'Select rigid/flexible solar panel(s) for flat area';
                            break;
                        case 11:
                            state = 'Connection of penals';
                            break;
                        case 12:
                            state = 'Select Charge Controller Type';
                            break;
                        case 13:
                            state = 'Select Charge Controller Model';
                            break;
                        case 14:
                            state = 'Select AC-DC Charger Model';
                            break;
                        case 15:
                            state = 'Select starting battery output voltage';
                            break;
                        case 'ac-one':
                            state = 'Select AC-DC Charger Model';
                            break;
                        case 'ac-two':
                            state = 'Select starting battery output voltage';
                            break;
                        case 'dc':
                            state = 'Select DC-DC Charger Model';
                            break;
                        case 16:
                            state = 'Select DC-DC Charger Model';
                            break;
                        default: {}
                    }
                    gtag('event', 'page_ask_for_help_rv', {
                        'send_to': 'G-VVXR7PJV6C',
                        'page_ask_for_help_rv': state
                    });
                }else if(this.headType == 3) {
                    gtag('event', 'page_ask_for_help_rv', {
                        'send_to': 'G-VVXR7PJV6C',
                        'page_ask_for_help_rv': "Solution Showcase"
                    });
                }
            },
            getLike() {
                this.$http.post(API.likesCount, {}).then(res => {
                    dealCode({
                        code: res.data.code,
                        successCallback: async () => {
                            let result = res.data.data;
                            this.count = result.count;
                            this.isLike = result.likes;
                        }
                    })
                });
            },
            handleLike() {
                
                if(!this.userToken) {
                    this.showLogin = true;
                }else {
                    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                    gtag('event', 'like_rv', {
                        'send_to': 'G-VVXR7PJV6C',
                        'like_rv': `{username:${userInfo.userNickname},email:${userInfo.userEmail}}`
                    });
                    if(!this.isLike) {
                        //点赞
                        this.$http.post(API.likes, {}).then(res => {
                            dealCode({
                                code: res.data.code,
                                successCallback: async () => {
                                    this.isLike = 1;
                                    this.highLike = true;
                                    this.count++;
                                }
                            })
                        });
                    }
                }
            },
            listenLogin(e) {
                this.userToken = e;
                localStorage.setItem('userToken', this.userToken);
                if(this.$listeners['loginSuccess']) {
                    this.$emit('loginSuccess');
                }else {
                    this.showLogin = false;
                    this.getLike();
                }
                
            }
        },
        filters: {
            countFilter(val) {
                let data = 0;
                if(val > 999999) {
                    data = '999K+';
                }else {
                    val += '';
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    data = val.replace(reg, ',');
                }
                return data;
            }
        }
    }
</script>

<style lang="scss" type="text/css">
    .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .vertical-center-modal .ivu-modal{
        top: 0;
    }

</style>
<style lang="scss" scoped type="text/css">
    .praise-box {
        position: fixed;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 77px;
        height: 166px;
        background-color: rgba(160, 160, 160, .78);
        border-radius: 10px 0 0 10px;
        overflow: hidden;
        .praise-content {
            width: 100%;
            height: 100%;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .block-box {
                width: 52px;
                height: 52px;
                background: #73726F;
                border-radius: 10px;
                margin-bottom: 2px;
                justify-content: center;
                cursor: pointer;
            }
            .text-box {
                color: #fff;
                font-size: 14px;
                cursor: default;
            }
            .text-box:not(:last-child) {
                margin-bottom: 10px;
            }
            .top-box {
                cursor: pointer;
                img {
                    max-width: 100%;
                    height: auto;
                }
            }
            .bottom-box {
                flex-direction: column;
                align-items: center;
                box-sizing: border-box;
                position: relative;
                .thumbs-up {
                    padding: 2px 0;
                    max-width: 100%;
                    height: auto;
                    cursor: pointer;
                    &.active {
                        animation: shake 1s;
                    }
                }
                .num-box {
                    font-size: 12px;
                    &.active {
                        color: #fff;
                    }
                }
                .heart-one,
                .heart-two,
                .heart-three {
                    width: 30px;
                    height: 27px;
                    background: url('~@/assets/images/heart.png') no-repeat center center;
                    position: absolute;
                    top: 0;
                    left: 20%;
                    opacity: 0;
                }
                .heart-one {
                    &.active {
                        animation: mymoveOne .5s forwards;
                    }
                }
                .heart-two {
                    &.active {
                        animation: mymoveTwo .5s .3s forwards;
                    }
                }
                .heart-three {
                    &.active {
                        animation: mymoveThree .5s .6s forwards;
                    }
                }
            }
        }
    }
    @keyframes mymoveOne{
        0% {top: 0;left: 20%;transform: scale(1) rotate(0); opacity: 0;}
        25% {top: -20px;left: 35%;transform: scale(.75) rotate(-10deg); opacity: 0.8;}
        50% {top: -30px;left: 30%;transform: scale(.55) rotate(-10deg);opacity: 0.8;}
        75% {top: -40px;left: 35%;transform: scale(.45) rotate(0);opacity: 0.8;}
        100% {top: -50px;left: 38%;transform: scale(.25) rotate(0);opacity: 0;}
    }
    @keyframes mymoveTwo{
        0% {top: 0;left: 20%;transform: scale(1) rotate(0); opacity: 0;}
        25% {top: -20px;left: 35%;transform: scale(.75) rotate(-10deg); opacity: 0.8;}
        50% {top: -30px;left: 30%;transform: scale(.55) rotate(-10deg);opacity: 0.8;}
        75% {top: -40px;left: 35%;transform: scale(.45) rotate(0);opacity: 0.8;}
        100% {top: -50px;left: 38%;transform: scale(.25) rotate(0);opacity: 0;}
    }
    @keyframes mymoveThree{
        0% {top: 0;left: 20%;transform: scale(1) rotate(0); opacity: 0;}
        25% {top: -20px;left: 35%;transform: scale(.75) rotate(-10deg); opacity: 0.8;}
        50% {top: -30px;left: 30%;transform: scale(.55) rotate(-10deg);opacity: 0.8;}
        75% {top: -40px;left: 35%;transform: scale(.45) rotate(0);opacity: 0.8;}
        100% {top: -50px;left: 38%;transform: scale(.25) rotate(0);opacity: 0;}
    }
    @keyframes shake {
        0%, 100% {
            -webkit-transform: translateX(0);
        }
        10%,
        30%,
        50%,
        70%,
        90% {
            -webkit-transform: translateX(-5px);
        }
        20%,
        40%,
        60%,
        80% {
            -webkit-transform: translateX(5px);
        }
    }
    //按钮弹窗
    .tipsModal-box {
        padding: 40px 60px;
        min-height: 20vh;
        ul {
            padding-left: 20px;
            margin-bottom: 25px;
            li {
                list-style-type: disc;
            }
        }
        .tipsModal-title {
            text-align: center;
            color: #2B2B2B;
            font-size: 1.8vh;
            font-weight: bold;
            margin-bottom: 20px;
        }
        .tipsModal-content {
            font-size: 1.6vh;
            text-align: center;
            color: #2B2B2B;
            margin-bottom: 40px;
        }
        .tipsModal-button {
            justify-content: space-between;
            >div {
                width: 45%;
                background: linear-gradient(0deg, #4D4D4D 0%, #727272 100%);
                box-shadow: 0px -2px 4px 0px rgba(98, 98, 98, 0.86);
                font-size: 1.8vh;
                text-align: center;
                border-radius: 10px;
                color: #fff;
                padding: 6px 0;
            }
            .selected {
                background: linear-gradient(0deg, #189EBD 0%, #17C0E7 100%);
                box-shadow: 0px -2px 3px 0px rgba(29, 181, 217, 0.74);
            }
            >div:hover {
                background: linear-gradient(0deg, #189EBD 0%, #17C0E7 100%);
                box-shadow: 0px -2px 3px 0px rgba(29, 181, 217, 0.74);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/praise/Praise.vue